import { lazy } from 'react';

const Error = lazy(() => import('./Error'));
const AccessDeniedComp = lazy(() => import('./AccessDeniedComp'));

export { Error, AccessDeniedComp };
